import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBikeAndRide = (props) => /* @__PURE__ */ _jsxs("svg", {
	height: 30,
	viewBox: "0 0 30 30",
	width: 30,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		fill: "currentColor",
		stroke: "currentColor",
		strokeMiterlimit: 10,
		strokeWidth: .5,
		transform: "translate(-1339 -363.15)",
		children: [
			/* @__PURE__ */ _jsx("path", { d: "m1350.693 379.979a2.236 2.236 0 0 1 -.2.953 2.407 2.407 0 0 1 -.542.752 2.442 2.442 0 0 1 -.795.492 2.665 2.665 0 0 1 -.971.175h-4.223v-9.2h4.311a1.733 1.733 0 0 1 .845.207 2.124 2.124 0 0 1 .643.538 2.484 2.484 0 0 1 .41.752 2.591 2.591 0 0 1 .145.849 2.462 2.462 0 0 1 -.34 1.276 2.126 2.126 0 0 1 -.945.862 2.237 2.237 0 0 1 1.216.868 2.5 2.5 0 0 1 .446 1.476zm-5.85-6.039v3.4h3.076a1.338 1.338 0 0 0 .611-.143 1.563 1.563 0 0 0 .485-.376 1.74 1.74 0 0 0 .315-.538 1.833 1.833 0 0 0 .113-.641 2.017 2.017 0 0 0 -.107-.661 1.627 1.627 0 0 0 -.3-.538 1.529 1.529 0 0 0 -.461-.363 1.251 1.251 0 0 0 -.58-.136zm4.967 5.883a1.927 1.927 0 0 0 -.114-.654 1.721 1.721 0 0 0 -.321-.557 1.684 1.684 0 0 0 -.492-.389 1.3 1.3 0 0 0 -.612-.149h-3.429v3.486h3.341a1.451 1.451 0 0 0 .637-.142 1.7 1.7 0 0 0 .517-.382 1.791 1.791 0 0 0 .346-.557 1.758 1.758 0 0 0 .128-.656z" }),
			/* @__PURE__ */ _jsx("path", {
				d: "m1364.185 379.909v.706h-1.563v1.7h-.794v-1.7h-1.563v-.706h1.563v-1.7h.794v1.7z",
				transform: "translate(-8.503 -2.512)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "m1371.905 382.35v-9.2h3.782a2.276 2.276 0 0 1 1.065.252 2.83 2.83 0 0 1 .838.661 3.046 3.046 0 0 1 .548.927 2.951 2.951 0 0 1 .2 1.049 3.19 3.19 0 0 1 -.145.965 3.017 3.017 0 0 1 -.4.829 2.47 2.47 0 0 1 -.624.622 2.175 2.175 0 0 1 -.819.343l2.194 3.551h-1l-2.106-3.4h-2.647v3.4zm.883-4.2h2.925a1.467 1.467 0 0 0 .712-.175 1.725 1.725 0 0 0 .548-.473 2.324 2.324 0 0 0 .353-.674 2.47 2.47 0 0 0 .126-.791 2.278 2.278 0 0 0 -.536-1.464 1.88 1.88 0 0 0 -.58-.454 1.535 1.535 0 0 0 -.7-.168h-2.849z",
				transform: "translate(-14.576)"
			})
		]
	}), /* @__PURE__ */ _jsx("circle", {
		cx: 15,
		cy: 15,
		fill: "none",
		r: 15
	})]
});
export default SvgBikeAndRide;
